import { cn } from "@/libs/utils";
import {
  getLanguageName,
  getSupportedLanguageCodes,
  LANGUAGE_NAME_MAP,
  LanguageCode,
} from "@/utils/LocaleUtil";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/v2-components/ui/dropdown-menu";
import ChevronDownIcon from "@/v2-components/core/icon/chevron-down-icon";
import { useState } from "react";

export function SelectLanguage({
  languageCode,
  setLanguageCode,
  countryCode = "US",
}: {
  countryCode?: string;
  languageCode: LanguageCode;
  setLanguageCode: (languageCode: LanguageCode) => void;
}) {
  const [open, setOpen] = useState(false);
  const supportedLanguageCodes = getSupportedLanguageCodes(countryCode);
  const length = supportedLanguageCodes.length;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger
        className={cn(
          "w-full rounded border border-coolgray-20 bg-white text-left hover:border-coolgray-40",
          length <= 1 && "pointer-events-none",
        )}
      >
        <div className="flex w-full items-center justify-between px-4 py-5">
          <div className="flex flex-1 items-center">
            <div className="text-coolgray-90">
              {getLanguageName(languageCode)}
            </div>
          </div>
          <ChevronDownIcon
            className={cn(
              "size-6 shrink-0 text-coolgray-50 transition-transform",
              open && "rotate-180",
              length <= 1 && "hidden",
            )}
          />
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        variant="select-like"
        className="border-px z-[200] flex w-[var(--radix-dropdown-menu-trigger-width)] flex-col overflow-hidden rounded border-coolgray-20 bg-white !p-0 shadow-md"
        sideOffset={6}
      >
        <div className="h-full flex-1 overflow-y-auto">
          <div className="py-4">
            {supportedLanguageCodes.map((_languageCode, index) => {
              const selected = _languageCode === languageCode;
              const isLast = index === supportedLanguageCodes.length - 1;

              return (
                <DropdownMenuItem
                  key={_languageCode}
                  onSelect={() => {
                    setLanguageCode(_languageCode);
                    setOpen(false);
                  }}
                  className="cursor-pointer px-4 hover:bg-coolgray-10"
                >
                  <div
                    className={cn(
                      `flex w-full items-center justify-between border-coolgray-10 py-3.5`,
                      !isLast && "border-b",
                    )}
                  >
                    <div className="flex grow items-center gap-2.5">
                      <div className="text-base text-coolgray-90">
                        {LANGUAGE_NAME_MAP[_languageCode]}
                      </div>
                    </div>
                    {selected && <CheckSVG />}
                  </div>
                </DropdownMenuItem>
              );
            })}
          </div>
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

const CheckSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z"
      fill="#21272A"
    />
  </svg>
);
